<template>
    <div class="item" :key="project.name">

        <a
            :target="project.coming_soon ? '_blank' : false"
            :rel="project.coming_soon ? 'nofollow noreferrer noopener' : false"
            class="content"
            :style="contentBgStyle(project.primaryColour)"
            :href="getProjectLink(project)"
        >
            <p class="title item--title" v-if="project.coming_soon !== true">{{project.name}}</p>
            <p class="item--company" v-if="project.coming_soon !== true">{{project.company}}</p>
            <p class="item--tags" v-if="project.coming_soon !== true"><em>{{project.tags}}</em></p>

            <p class="title item--title" v-if="project.coming_soon === true">Coming Soon</p>
            <p class="item--company" v-if="project.coming_soon === true">{{project.shortlink}}</p>
            <p class="item--tags" v-if="project.coming_soon === true"><em>{{project.developed_by}}</em></p>
        </a>

        <img class="item--background" :src="getThumbnail(project.thumbnail)" :alt="project.name + ' thumbnail'" />
    </div>
</template>

<script>

export default {
    name: 'PortfolioItem',
    props: ['project'],
    data() {
        return {
            //
        }
    },
    methods: {
        slugify(project) {
            return '/portfolio/' + project.name.toLowerCase().replace(/ /g, '-');
        },
        getThumbnail(path) {
            return require(`@/assets/images/thumbnails/${path}`);
        },
        contentBgStyle(primaryColour) {
            return {
                'background-color': primaryColour,
            }
        },
        getProjectLink(project) {
            if(project.coming_soon === true) {
                return project.link;
            } else {
                return this.slugify(project);
            }
        }
    }
}
</script>

<style lang="scss">

</style>
